function scrollAnchorLinks({ targetEl, siteHeaderHeight }) {
	const positionY = targetEl.offsetTop - siteHeaderHeight;
	window.scrollTo({
		top: positionY,
		behavior: 'smooth',
	});
}

export default (targetEl, headerHeight = 0) => {
	if (targetEl) {
		scrollAnchorLinks({ targetEl, siteHeaderHeight: headerHeight });
		return true;
	}
	return false;
};
